/**
 * @generated SignedSource<<e061248a91538fe75c27393e8b75172e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommentsModeEnum = "qa" | "standard" | "%future added value";
export type ResourceTypeEnum = "authorProfile" | "campaign" | "category" | "clientError" | "customStory" | "diningReport" | "embedStory" | "homepage" | "image" | "internalCategory" | "internalSuperCat" | "linkPost" | "loopNav" | "map" | "mmaEvent" | "mmaFight" | "mmaFighter" | "mmaPromotion" | "mmaWeightClass" | "neighborhood" | "package" | "page" | "post" | "product" | "productBrand" | "quickPost" | "redirect" | "series" | "startHere" | "stream" | "superCat" | "tag" | "vault" | "venue" | "videoGame" | "videoGamePlatform" | "videoPost" | "volumeVideo" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UtahSlideMeta_feedContentResource$data = {
  readonly additionalBylines: string;
  readonly authors: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly chorusId: number | null;
  readonly chorusUuid: string | null;
  readonly comments: {
    readonly enabled: boolean;
    readonly mode: CommentsModeEnum;
  };
  readonly dek: {
    readonly plaintext: string;
  };
  readonly globalId: string;
  readonly id: string;
  readonly permalink: string;
  readonly resourceType: ResourceTypeEnum;
  readonly title: string;
  readonly " $fragmentType": "UtahSlideMeta_feedContentResource";
};
export type UtahSlideMeta_feedContentResource$key = {
  readonly " $data"?: UtahSlideMeta_feedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"UtahSlideMeta_feedContentResource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UtahSlideMeta_feedContentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorProfileResourceType",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalBylines",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RichTextType",
      "kind": "LinkedField",
      "name": "dek",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plaintext",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusUuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resourceType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permalink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CommentsType",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedContentResourceInterface",
  "abstractKey": "__isFeedContentResourceInterface"
};

(node as any).hash = "fb039406304b19b513e1cd72d462dff5";

export default node;
